import { useStoreNameData, setStoreNameData, setIsLoadingAggregators } from '../context/storeNameAtoms';
import { useServices } from '../../../context';
import { isWixPaymentProviderSupported } from '../utils';

export function useStorePayments() {
  const { isAcceptedPayments } = useStoreNameData();
  const { chatServiceDs: chatService } = useServices();

  function handleAcceptPaymentsChange() {
    setStoreNameData({
      isAcceptedPayments: !isAcceptedPayments,
    });
  }
  async function handleShowAcceptPayments() {
    setIsLoadingAggregators(true);
    const paymentAggregators = await chatService.getPaymentAggregators();

    const shouldShowByProvider = isWixPaymentProviderSupported(paymentAggregators);
    setStoreNameData({
      isShowAcceptPayments: shouldShowByProvider,
      isAcceptedPayments: shouldShowByProvider,
      isLoadingAggregators: false,
    });
  }

  return {
    handleAcceptPaymentsChange,
    handleShowAcceptPayments,
  };
}
